module.exports = __webpack_public_path__ + "static/media/View_detail.f365c93c.svg";